import React, { useState, lazy } from 'react';
import AuthenticatedLayout from '../layouts/AuthenticatedLayout.jsx';
import { TbTimelineEventExclamation } from 'react-icons/tb';
import { TestableCard, TestableText } from '../components/general/TestableComponents.jsx';

import { Tabs, TabsHeader, TabsBody, Tab, TabPanel } from "@material-tailwind/react";

import SuspenseWithLoading from '../components/cards/shared/SuspenseWithLoading.jsx';
import OrganisationEventMetrics from '../components/cards/events/organisation/OrganisationEventMetrics.jsx';

// Lazy load the table component
const OrganisationEventsTable = lazy(() => 
  import('../components/cards/events/organisation/OrganisationEventsTable.jsx')
);

export default function OrganisationEvents() {
    const [activeTab, setActiveTab] = useState("project");
    const [testTabLoaded, setTestTabLoaded] = useState(false);

    const handleTabChange = (tabValue) => {
        setActiveTab(tabValue);
        if (tabValue === "test") {
            setTestTabLoaded(true);
        }
    };

    return (
        <AuthenticatedLayout>
            <TestableCard dataTestId="org-events-card" className="mb-6">
                <div data-testid="oec-events-header" className='flex flex-col md:flex-row items-start md:items-center mb-5 pb-2 border-b border-gray-400 gap-2 space-y-2 md:space-y-0'>
                    <div className="w-full flex flex-row items-center">
                        <TbTimelineEventExclamation className="h-10 w-10 mr-3" />
                        <TestableText dataTestId="oec-events-title" variant="h2" className="mr-1">Events</TestableText>
                    </div>
                </div>

                <Tabs value={activeTab} className="mt-6">
                    <TabsHeader className="font-bold text-sm">
                        <Tab value="project" onClick={() => handleTabChange("project")}>
                            Project Events
                        </Tab>
                        <Tab value="test" onClick={() => handleTabChange("test")}>
                            Test Events
                        </Tab>
                    </TabsHeader>

                    <div className="mt-6 mb-6">
                        <OrganisationEventMetrics event_level={activeTab === "project" ? "Project" : "Test"} />
                    </div>

                    <TabsBody className="mt-6">
                        <TabPanel value="project">
                            <SuspenseWithLoading>
                                <OrganisationEventsTable event_level="Project" dataTestId="project-events-table" />
                            </SuspenseWithLoading>
                        </TabPanel>

                        {testTabLoaded && (
                            <TabPanel value="test">
                                <SuspenseWithLoading>
                                    <OrganisationEventsTable event_level="Test" dataTestId="test-events-table" />
                                </SuspenseWithLoading>
                            </TabPanel>
                        )}
                    </TabsBody>
                </Tabs>
            </TestableCard>
        </AuthenticatedLayout>
    );
}